import React from 'react';
import { bool, func } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';

const DraftButton = ({ disabled = false, onClick }) => (
  <Button
    disabled={disabled}
    variant="outlined"
    onClick={onClick}
    sx={theme => ({
      minWidth: '90px',
      fontSize: '15px',
      color: theme.palette.black,
    })}
  >
    {I18n.t('AcknowledgementCreate.Save draft')}
  </Button>
);
DraftButton.propTypes = {
  disabled: bool,
  onClick: func.isRequired,
};

export default DraftButton;
